import { render } from "./Superadmin.vue?vue&type=template&id=2668ea20&scoped=true"
import script from "./Superadmin.vue?vue&type=script&lang=js"
export * from "./Superadmin.vue?vue&type=script&lang=js"

import "./Superadmin.vue?vue&type=style&index=0&id=2668ea20&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2668ea20"]])

export default __exports__